import script from "./materialIn.vue?vue&type=script&setup=true&lang=ts"
export * from "./materialIn.vue?vue&type=script&setup=true&lang=ts"

import "./materialIn.vue?vue&type=style&index=0&id=ad1b8804&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad1b8804"]])

export default __exports__